import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getGlobalMessageTypes } from "../../../../axios/api/services";
import {
  fulfilledThunkState,
  initialThunkState,
  pendingThunkState,
  rejectedThunkState,
  commonThunkCondition,
} from "@duosoftbg/nacid-components";

const sliceName = "appData/globalMessageTypes";
const globalMessageTypesSlice = createSlice({
  name: sliceName,
  initialState: initialThunkState([]),
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(globalMessageTypesThunk.pending, (state, action) => {
      return pendingThunkState(state);
    });
    builder.addCase(globalMessageTypesThunk.fulfilled, (state, action) => {
      const { data } = action.payload;
      return fulfilledThunkState(data);
    });
    builder.addCase(globalMessageTypesThunk.rejected, (state, action) => {
      return rejectedThunkState([]);
    });
  },
});

export const globalMessageTypesThunk = createAsyncThunk(
  `${sliceName}/globalMessageTypesThunk`,
  async () => {
    const response = await getGlobalMessageTypes()();
    return { data: response };
  },
  {
    condition: (_, { getState, extra }) => {
      return commonThunkCondition(getState()["AppData"]?.globalMessageTypes);
    },
  },
);

export default globalMessageTypesSlice.reducer;
